import React, { useEffect, useState } from 'react'
import DatePicker from "react-datepicker"
import { Doc } from "@/services/model/docs"
import { Translates } from '@/services/repository/i18n'
import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'

import "react-datepicker/dist/react-datepicker.css"
import './index.css'

export type DateRange = {
  from: Date
  to: Date
}

export type DateRangeSetter = (range: DateRange) => void

export function DateTimeRangeBody({ services, session, translates, range, setter, onClose }: { translates: Translates, services: Services, range: DateRange, setter: DateRangeSetter, session: CurrentSession | undefined, onClose: ()=>void }) {
  const [newRange, setNewRange] = useState(range)

  // @ts-ignore: Unreachable code error
  const ReactDatePicker = DatePicker.default ?? DatePicker;
  /* tslint:enable */

  return (
    <form className="main-form" onSubmit={(e) => {
      e.preventDefault()
      setter(newRange)
      onClose()
    }}>
      {/* From Date */}
      <div className="form-field">
        <label htmlFor="from-date">{translates.for('popup.datetime_range.from')}:</label>
        <ReactDatePicker
          id="from-date"
          name="from"
          selected={newRange.from ? new Date(newRange.from) : null}
          onChange={(date: Date|string) => {
            date = new Date(date)
            if (range.to<date) {
              return
            }
            setNewRange({
              ...newRange,
              from: date || range.from
            })
          }}
          showTimeSelect={true}
          timeIntervals={15}
          timeFormat="HH:mm"
          dateFormat="yyyy-MM-dd HH:mm"
          maxDate={range.to || undefined}
          // placeholderText="Select start date and time"
          className="border rounded p-2"
          portalId="tooltip-wrap"
        />
      </div>

      {/* To Date */}
      <div className="form-field">
        <label htmlFor="to-date">{translates.for('popup.datetime_range.to')}:</label>
        <ReactDatePicker
          id="to-date"
          name="to"
          selected={newRange.to ? new Date(newRange.to) : null}
          onChange={(date: Date|string) => {
            date = new Date(date)
            if (range.from>date) {
              return
            }
            setNewRange({
              ...newRange,
              to: date || range.to
            })
          }}
          showTimeSelect
          timeIntervals={15}
          timeFormat="HH:mm"
          dateFormat="yyyy-MM-dd HH:mm"
          placeholderText=""
          minDate={newRange.from || undefined}
          className="border rounded p-2"
          portalId="tooltip-wrap"
        />
      </div>
      <button className="submit-button" type="submit">{translates.for('popup.datetime_range.submit')}</button>
    </form>
  );
}